export const bandwidthConvertor = (inputNum: number) => {
  const roundedNum = Math.round(inputNum);
  return `${roundedNum} KB/S`;
};
